export default __webpack_public_path__ + "static/media/hr-recruting.92f8b77c.svg";